<template>
  <div id="invoice-view">
    <div class="invoice-view-header">
      <h1>{{$_('my_invoice')}}</h1>
      <p>{{$_('my_invoice_text')}}</p>
    </div>
    <div>
      <OutstandingHeader />
    </div>
    <div>
      <InvoiceResearch />
    </div>
    <div>
      <InvoiceList />
    </div>
  </div>
</template>

<script>

import InvoiceList from '@/modules/facture/components/InvoiceList';
import InvoiceResearch from '@/modules/facture/components/InvoiceResearch';

import OutstandingHeader from '@/modules/encour/components/OutstandingHeader';

export default {
  components: {
    InvoiceList,
    InvoiceResearch,
    OutstandingHeader
  },
  created() {
    this.$store.dispatch('facture/RESET_INVOICE_RESEARCH');

    localStorage.removeItem('satabapp-text');
  }
}
</script>

<style scoped>

.invoice-view-header {
  padding: 15px;
}

</style>